import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { LoadClinicalEvidenceEvents } from '@troyai/portal/health-timeline/data-access';
import { LoadEpisode } from '@troyai/portal/intervention-episodes/data-access';
import {
  demoMemberId,
  demoSettings,
  resetDemoSettings,
  updateDemoSettings,
} from '@troyai/portal/investor-demo/core';

import { DemoStore } from './demo-store';

/** An open episode of the demo member: `/patients/<member id>/episodes/<episode id>`, query and tabs allowed. */
function demoEpisodeUrl(): RegExp {
  return new RegExp(`^/patients/${demoMemberId()}/episodes/(\\d+)(?=[/?#]|$)`);
}

/**
 * "+3 days": moves the demo clock three days on, which makes the future items visible (the store
 * filters at read time), then re-reads what is on screen. On an open episode that is the episode
 * and, if a clinical-event list was read, that list again; this needs no navigation, so it works
 * with the Add observation drawer open. Anywhere else the page reloads. A second call does nothing.
 */
export function jumpThreeDays(deps: { store: Store; demo: DemoStore; router: Router }): void {
  if (demoSettings().jumped) {
    return;
  }
  updateDemoSettings({ jumped: true });

  const episode = demoEpisodeUrl().exec(deps.router.url);
  if (!episode) {
    location.reload();
    return;
  }

  deps.store.dispatch(
    new LoadEpisode({ memberGlobalId: demoMemberId(), episodeId: Number(episode[1]) })
  );
  const category = deps.demo.data().lastEvidenceCategory;
  if (category !== undefined) {
    deps.store.dispatch(
      new LoadClinicalEvidenceEvents({ memberGlobalId: demoMemberId(), category })
    );
  }
}

/** Back to the start of the story: seed data, the clock on the story day, the Care Console. */
export function resetDemo(demo: DemoStore): void {
  demo.reset();
  resetDemoSettings();
  location.assign('/care-console');
}

/** Leaves demo mode and goes to the normal app. */
export function demoOff(): void {
  updateDemoSettings({ on: false });
  location.assign('/');
}
